import {Row, Select} from "antd";
import styled from "styled-components";

export const Center = styled.div`
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Box = styled.div`
    height: 35px;
    min-width: 96px;
    padding: 0 10px;
    border-radius: 4px;
    display: flex;
    margin: 0 7px;
    align-items: center;
    justify-content: center;
    border: 2px solid ${({color}) => color};
    transition: background 0.3s ease;
    &:hover {
        background-color: ${({color}) => color};
        & > div,
        svg {
            color: white;
        }
    }
`;

export const CollapseHeaderNumber = styled.div`
    font-weight: bold;
    font-size: 18px;
    text-align: center;
    margin-left: 5px;
    color: ${({color}) => color};
`;
export const OptionsRow = styled(Row)`
    @media (max-width: 768px) {
        width: 100%;
        heigh: 100%;
    }
`;
export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            min-width: 197px;
            font-size: 12px;
        }
    }
`;
